import { ResourceLibraryItem } from '../types/resourceLibraryItems';

// Counts of items per category, with parent categories counted per item
export type Counts = {
    brands: Map<string, number>;
    productGroups: Map<string, number>;
    productApplications: Map<string, number>;
    resourceTypes: Map<string, number>;
};

/**
 * Calculate counts for given resource library items.
 * Parent categories are counted if any child item belongs to them.
 */
export function getCounts(
    resourceLibraryItems: ResourceLibraryItem[],
    productGroupById: Record<string, { id: string; parent?: any }>,
    productApplicationById: Record<string, { id: string; parent?: any }>,
    resourceTypeById: Record<string, { id: string; parent?: any }>
): Counts {
    const brands = new Map<string, number>();
    const productGroups = new Map<string, number>();
    const productApplications = new Map<string, number>();
    const resourceTypes = new Map<string, number>();

    const countOccurrences = <T extends { id: string; parent?: T }>(
        relObjIds: string[],
        map: Map<string, number>,
        parentById: Record<string, T>
    ) => {
        const counted = new Set<string>();
        const uniqueIds = Array.from(new Set(relObjIds));
        uniqueIds.forEach((relObjId) => {
            map.set(relObjId, (map.get(relObjId) || 0) + 1);
            counted.add(relObjId);
            let parent = parentById[relObjId]?.parent;
            while (parent && !counted.has(parent.id)) {
                map.set(parent.id, (map.get(parent.id) || 0) + 1);
                counted.add(parent.id);
                parent = parentById[parent.id]?.parent;
            }
        });
    };

    resourceLibraryItems.forEach((item) => {
        if (item.brandId) {
            brands.set(item.brandId, (brands.get(item.brandId) || 0) + 1);
        }
        countOccurrences(item.productGroupIds, productGroups, productGroupById);
        countOccurrences(item.productApplicationIds, productApplications, productApplicationById);
        countOccurrences([item.resourceTypeId], resourceTypes, resourceTypeById);
    });

    return { brands, productGroups, productApplications, resourceTypes };
}
